import { getCookie } from 'bv';
import * as BVFetch from 'bv-fetch';

// Dependencies:
// - document
// - navigator

const { navigator } = window;

window.fishnet = window.fishnet || {};

const updateFallbacks = (data) => {
  /* Example of a response from fetch or pgate:
    {
     "url": "test222.mobi",
     "fbs": [
       "test331.mobi",
       "test332.mobi",
       "test333.mobi"
     ]
   }
  */
  if (data.fbs) {
    navigator?.serviceWorker?.controller?.postMessage({
      command: 'setFallbackDomains',
      fallbackDomains: data.fbs,
    });
  }
};

const fetch = () => {
  const type = getCookie('_vcf') ? 'post' : 'get';
  BVFetch[`${type}JSON`]('/fnet/f', { url: document.location.host }).then(updateFallbacks);
};

const register = (eventBus) => eventBus.registerHandler(`/fnet/${document.location.host}`, updateFallbacks);

const init = (eventBus) => {
  fetch();
  register(eventBus);
};

window.fishnet.fallbackUpdater = {
  init,
};
